import { APP_SNACKBAR_SHOW, APP_SNACKBAR_HIDE } from './actions'

const initialState = {
  message: '',
  isOpen: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_SNACKBAR_SHOW:
      return { message: action.message, isOpen: true }

    case APP_SNACKBAR_HIDE:
      return { message: '', isOpen: false }

    default:
      return state
  }
}
